var PES = PES || {};
PES.OnlineGeneral = function () {
    var toggleHeaderImageOnHover = function () {
        var mainImage = $(".main-img-hover");
        $(mainImage).css("display", "block");

        $(".hover-btn").hover(
            function () {
                $(mainImage).css("display", "none").css("opacity", "0").siblings("img").css("display", "block").css("opacity", "1");
            },
            function () {
                $(mainImage).css("display", "block").css("opacity", "1").siblings("img").css("display", "none").css("opacity", "0");
            }
        );
    };

    var setupTabsContainer = function () {
        $(".tab-area .tab").on("click",
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var tab = $(this);
                var targetId = tab.find(".tab-btn").attr("data-href");
                var target = $(".tab-area " + targetId);

                var currentTargetIsVisible = tab.hasClass("active");

                var hideAllTargets = function () {
                    var allTargets = $(".tab-area .tab-content-item");
                    allTargets.removeClass("active");
                    var allTabs = $(".tab-area .tab");
                    allTabs.removeClass("active");
                };

                hideAllTargets();

                if (!currentTargetIsVisible) {
                    target.addClass("active");
                    tab.addClass("active");
                }
            });
    };

    var init = function () {
        toggleHeaderImageOnHover();
        setupTabsContainer();
        $(".hidden-image-hover").css("display", "none");
    };

    return {
        init: init
    };
   
}();